import React from "react";
import { Box, Button, Card, ThemeProvider, Typography } from "@mui/material";
import theme from "../../assets/theme/theme";
import RefreshIcon from "@mui/icons-material/Refresh";

interface IProps {
    error?: Error;
    resetErrorBoundary?: () => void;
}

export function ErrorFallBackUI(props: IProps){
    return (
        <ThemeProvider theme={theme}>
          <>
            <div className="error-page p-4">
              <div className="text-center mb-4">
                <img
                  src="/logo-transparent.svg"
                  alt="logo"
                  className="signin-logo"
                />
              </div>
              <Card variant="outlined" className="card p-4 text-center">
                 <Typography variant="h5" className="error-sub-title">
                 Something went wrong, Please try refreshing the page.
                            </Typography>
                
                            <Typography variant="body1" className="page-error-text">
                            {props.error?.message}
                            </Typography>
                
                <div className="text-center">
                  <Box sx={{}} className="action-container">
                    <Button variant="contained" onClick={props.resetErrorBoundary} startIcon={<RefreshIcon />}>
                      Try again
                    </Button>
                  </Box>
                </div>
              </Card>
            </div>
          </>
        </ThemeProvider>
      );
    }
    
